<template>
  <div class="hello">
    <h1 :class="{'hide' : picking !== false}">{{ msg }}</h1>
    

    <Sticks :sticks="sticks" :choice="pick" :picking="picking" :key="stickKey" @picked="picking=true" :cup="cup" @remove="remove" />


    <transition name="fade" mode="out-in" >
    <div v-if="picking === false" :key="1">
    
          <div class="buttons">
            <button class="addstick" v-on:click="addstick">+ Add a stick</button>
            
            <button class="options-btn" @click="options=true">Options</button>
            <button class="reset" v-on:click="reset">Clear</button>
            
            <button class="bigger pick-btn" v-on:click="pickstick(0)">Pick one!</button>
          </div>

          <Modal :show="options" @close="options=false">
            <button class="add-to-templates" @click="addingTemplate=true; options=false;">+ Add To Templates</button>
              <button class="picktemplate" v-on:click="picktemplate(); options=false;">Pick a template...</button>
              <button class="addmultiple" v-on:click="addmultiplesticks(); options=false;">Add multiple sticks...</button>
              <button class="resetpicked" v-on:click="resetpickedsticks(); options=false;" v-if="sticksAreOut">Reset Picked Sticks</button>
              <button class="btn cup-btn" @click="changeCup=true; options=false;">Change Cup</button>
              <button class="cancel" @click="options=false;">Close. Nevermind.</button>
          </Modal>
    
          <div class="help">
            <div v-show="help" class="helpbox">
              <ol>
                <li>Think of the things you need to make a decision about</li>
                <li>Write the things down on the sticks</li>
                <li>Click "Pick one!" to mix the sticks up and make a choice</li>
                <li>Click the little (X) on the right side of the stick to remove it</li>
              </ol>
            </div>
            <button class="help" v-on:click="help = !help">
              <span v-if="!help">what's this?</span>
              <span v-else>ok, got it</span>
            </button>
          </div>
    
          <Modal :show="addingmultiple" @close="addingmultiple=false" :boxClasses="'addmultiplebox'">
            
            <h3>Enter each choice on a new line.</h3>
            <textarea v-model="multiplesticks"></textarea>
            <button v-on:click="addthemall">Add them all!</button>
            <button v-on:click="canceladding" class="cancel">Nevermind. Cancel.</button>
          
          </Modal>
    
          <Modal :show="pickingtemplate" @close="pickingtemplate=false" boxClasses="pickatemplate">
            <Templates v-on:cancel="cancelpickingtemplate" v-on:setsticks="setsticksfromtemplate" />
          </Modal>
    
          <Modal :show="changeCup" @close="changeCup=false">
            <CupPicker @cancel="changeCup=false" :current="cup" @getCup="setCup" @cancelCup="changeCup = false" />
          </Modal>

          <Modal :show="addingTemplate" @close="addingTemplate=false; newTemplateName=''" >
            
            <h2>New Template's Name?</h2>
            <input type="text" name="newTempName" class="new-temp-name" v-model="newTemplateName">
            <button class="btn save-btn" @click="addToTemplates">Save</button>
            <button class="btn cancel" @click="addingTemplate=false; newTemplateName='';">Nevermind. Cancel.</button>
          
          </Modal>
      </div>

      <div v-if="picking === true" :key="2">
      <button class="bigger" @click="pickanother">Pick Another</button>
      <button class="bigger" v-on:click="goback">Go Back</button>
      </div>
    </transition>

  </div>
</template>

<script>
import Templates from './Templates.vue'
import Sticks from '@/components/Sticks'
import CupPicker from './CupPicker'
import Modal from './Modal'

export default {
  name: 'Main',
  components: {
    Templates,
    Sticks,
    CupPicker,
    Modal
  },  
  props: {
    msg: String
  },
  data: function() {
    return {
      sticks: [{choice:''},{choice:''},{choice:''}],
      pick: false,
      help: false,
      addingmultiple: false,
      multiplesticks: '',
      pickingtemplate: false,
      sticksAreOut: false,
      picking: false,
      stickKey: 0,
      addingTemplate: false,
      newTemplateName:'',
      changeCup: false,
      cup: 'cup',
      options: false,
      test: false
    }
  },
  methods: {
    addstick: function() {
      this.sticks.push({choice:''});
    },
    pickstick: function(runCount) {
      //todo - this should only pick from the remaining unpicked sticks
      //if only one stick is left, maybe display a message or something
      this.picking = 'processing';
      this.sticks.forEach(function(stick, index) {
        if(stick.choice==''){stick.choice='Choice '+(index+1);}
      });
      const pick = Math.floor(Math.random() * this.sticks.length);

      if(this.sticks[pick].picked === true && runCount <= this.sticks.length){
        this.pickstick(runCount+1);
      }else if(this.sticks[pick].picked === true && runCount >= this.sticks.length){
        this.sticks.forEach(stick => {
          stick.picked = false;
        });
        this.pickstick(0);
      }else{
        this.pick = pick;
      }
    },
    addmultiplesticks: function() {
      this.addingmultiple = true;
    },
    addthemall: function() {
      //turn each line in the textarea into an array
      let ms = this.multiplesticks;
      let lines = ms.replace(/\r\n/g,"\n").split("\n").filter(line => line);
      //use a temporary array to save non-empty values from current sticks
      let tempsticks = [];
      this.sticks.forEach((stick) => {
        if(stick.choice != '') { tempsticks.push(stick.choice); }
      });
      //add any current sticks to the new ones being added
      let allLines = tempsticks.concat(lines);
      //now clear the sticks and set them to these
      this.sticks = [];
      allLines.forEach((line) => {
        this.sticks.push({choice:line});
      });
      //make sure there are at least three choices
      while(this.sticks.length < 3) {
        this.sticks.push({choice:''});
      }
      this.canceladding();
    },
    canceladding: function() {
      this.addingmultiple = false;
      this.multiplesticks = '';
    },
    picktemplate: function() {
      this.pickingtemplate = true;
    },
    cancelpickingtemplate: function() {
      this.pickingtemplate = false;
    },
    setsticksfromtemplate: function(choices) {
      this.sticksAreOut=false;
      this.sticks = [];
      choices.forEach((line) => {
        this.sticks.push({choice:line});
      });
      this.pickingtemplate = false;
    },
    pickanother: function() {
      this.sticks[this.pick].picked = true;
      
      this.sticksAreOut = true;
      this.picking = 'reset'
      setTimeout(() => {
        this.picking = false
        this.pick = false;
      }, 1000);
    },    
    goback: function() {
      this.picking = 'reset'
      setTimeout(() => {
        this.picking = false
        this.pick = false;
      }, 1000);
    },
    reset: function() {
      this.sticks = [{choice:''},{choice:''},{choice:''}];
    },
    remove: function(stickIndex) {
      this.sticks.splice(stickIndex, 1);
    },
    resetpickedsticks(){
      this.sticksAreOut = false;

      this.sticks.forEach(stick => {
        stick.picked = false
      });

      this.stickKey++
    },
    addToTemplates(){
      let sticksArr = []
      this.sticks.forEach(stick => {
        sticksArr.push(stick.choice)
      })
      let newTemp = {// eslint-disable-line 
        title: this.newTemplateName,
        choices: [...sticksArr]
      }; 
      let existingTemps = JSON.parse(localStorage.getItem("localTemplates"))
      if(existingTemps == null) existingTemps = []
      existingTemps.push(newTemp);
      localStorage.setItem("localTemplates", JSON.stringify(existingTemps))
      
      this.addingTemplate = false
      this.newTemplateName = ''
    },
    setCup(cup){
      this.cup = cup;
      this.changeCup = false
      localStorage.setItem('cup', cup)
    }
  },
  mounted() {
    let cup = localStorage.getItem('cup')
    if(cup == null) cup = 'cup'
    this.cup = cup
  },
}
</script>

<style lang="scss">
$font: 'Gaegu', cursive, sans-serif;
h1 {
  font: normal 28px $font;
  text-decoration: underline;
  transition: opacity 500ms;

  &.hide{
    opacity: 0;
  }
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
ul li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.buttons{
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: 'add add' 'opt clear' 'pick pick';
  max-width: 320px;
  margin: 0 auto;
  grid-gap: 1em;

  button{
    width: 100%;
    margin: 0;
  }

  .addstick{
    grid-area: add;
    height:44px;
    margin:0 auto;
    padding:2px 30px 2px 10px;
    background: linear-gradient(rgba(255,255,255,0.5), rgba(255,255,255,0.5)), transparent url('../assets/stick1.jpg') no-repeat center center;
    background-size: contain;
    border-radius:20px;
    display: flex;
    align-items: center;
    border: none;
    font-size: 24px;
    font-weight: bold;
    transition: all 250ms;

    &:hover{
      transform: scale(1.1);
    }
  }

  .options-btn{
    grid-area: opt;
  }

  .reset{
    grid-area: clear;
  }

  .pick-btn{
    grid-area: pick;
    margin: 0;
    width: 100%;
    border-radius: 8px;
    padding: 10px;
    background: #cfc;
    font-weight: bold;
  }
}

button {
  margin:10px auto;
  padding:1px 10px;
  background:#ffc;
  border:solid 1px #000;
  border-radius: 16px;
  color:#333;
  width: 260px;
  text-align: center;
  display: block;
  cursor: pointer;
  font: normal 18px/20px 'Gaegu', cursive, sans-serif;
  box-shadow: 0 1px 2px rgba(0,0,0,0.3);
  transition: all 250ms;
  &.bigger { 
    width: 200px;
    margin-top: 30px;
    border-radius: 8px;
    padding: 10px; 
    background: #cfc;
    font-weight: bold;
    &:hover { transform: scale(1.1,1.1); }
  }
  &.help {
    text-decoration: underline;
    box-shadow: none;
    border: none;
    background: transparent;
    color: #008;
  }
  &.cancel { background: #ddd; }
  &.reset { background: #fcc; }
}
.stick {
  width:320px;
  height:44px;
  margin:10px auto;
  padding:2px 30px 2px 10px;
  background: transparent url('../assets/stick1.jpg') no-repeat center center;
  background-size: contain;
  border-radius:20px;
  display: flex;
  align-items: center;

  &:nth-of-type(3n+1) {
    background-image: url('../assets/stick2.jpg');
  }  
  &:nth-of-type(3n+2) {
    background-image: url('../assets/stick3.jpg');
  }  
  input { 
    border: none;
    background: transparent;
    color: rgba(0,0,0,0.9);
    width: 100%;
    line-height:40px;
    height:40px;
    font: bold 24px/40px 'Gaegu', cursive, sans-serif;
    outline: none;
  }
  .remove {
    display: block;
    font:normal 20px/16px Arial,sans-serif;
    width:20px;
    height:20px;
    border-radius:10px;
    color: rgba(0,0,0,0.6);
    border:solid 2px rgba(0,0,0,0.6);
    cursor: pointer;
    flex: 0 0 20px;
    &:hover { color: rgba(255,0,0,0.9); border-color: rgba(255,0,0,0.9); }
  }
  &.picked {
    filter: grayscale(90%);
    input { pointer-events: none; }
    
  }
}
::-webkit-input-placeholder,
::-moz-placeholder,
:-ms-input-placeholder,
:-moz-placeholder,
::placeholder {
  color: rgba(0,0,0,0.5);
}
.helpbox {
  padding: 10px;
  max-width: 360px;
  text-align: left;
  margin: 0 auto;
}

.addmultiplebox textarea {
  width: 100%;
  height: 100px;
  margin: 10px 0;
}

.new-temp-name{
  width: 260px;
  border-radius: 45px;
  padding: 5px 10px;
  font-size: 1.5rem;
  font-family: $font;
  text-align: center;
  border: solid 2px #000;
}

//transitions
//====================================================

.fade-enter-active, .fade-leave-active {
  transition: all 500ms;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

//END transitions====================================================
</style>
